import moment from 'moment'

export interface IMacstoreBarcodeInput {
  campaign?: string
  storeCode: string | number
  imei: string
  discountAmount: string | number
  sku: string
  id: string | number
}

/**
 * Construye los textos de los códigos de barra de Macstore para un dispositivo.
 * Misma lógica usada al firmar (ModalSign): campaña '4L' genera 5 barcodes,
 * cualquier otra campaña genera 4. Devuelve solo los textos no vacíos.
 */
export const getMacstoreBarcodeTexts = (device: IMacstoreBarcodeInput): string[] => {
  const fecha = moment().tz('America/Mexico_City').locale('es').format('DDMMYYYY')
  const discount = String(device.discountAmount).padStart(5, '0')

  let texts: string[]
  if (device.campaign === '4L') {
    texts = [
      '(1)' + String(device.storeCode) + fecha + discount + '992i4L',
      '(2)' + String(device.imei),
      '(3)' + String(device.imei),
      '(4)' + String(device.sku),
      'REUSE-' + String(device.id)
    ]
  } else {
    texts = [
      '(1)' + String(device.storeCode) + fecha + discount + '992',
      '(2)REUSE-' + String(device.id),
      '(3)' + String(device.imei),
      '(4)' + String(device.sku)
    ]
  }

  return texts.filter(text => text !== '')
}
